import { combineReducers } from '@reduxjs/toolkit'
import member from './member/member.reducer'
import settings from './settings/settings.reducer'
import organisations from './organisations/organisations.reducer'
import loaded from './loaded/loaded.reducer'
import organisation_user from './organisation-user/organisation-user.reducer'
import reports from './reports/reports.reducer'

export default combineReducers({
  reports,
  member,
  settings,
  organisations,
  loaded,
  organisation_user,
})
